<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-4">

      <amplify-authenticator class="evready-amplify" [hideSignUp]="true">
        <ng-template
          amplifySlot="authenticated"
          let-user="user"
          let-signOut="signOut"
        >
          <div class="text-center">
            <p class="text-muted">Welcome, {{ user.username }}!</p>
            <p class="text-muted">Redirecting to app...</p>
            <!-- Set flag to trigger redirect -->
            @if (setAuthenticatedAndRedirect(user)) {
              <!-- This will always render since the method returns true -->
            }
          </div>
        </ng-template>
      </amplify-authenticator>

    </div>
  </div>
</div>
